<template>
    <div>
        <div v-if="this.$store.state.device.isMobile">
            <navbarTop></navbarTop>
            <navbarBottom></navbarBottom>
            <div style="position: relative;">
                <b-form class="form">
                    <b-row class="progress_row">
                        <b-col cols="2" class="progress_col"><span class="dot_active" :style="{'border': '3px solid'+this.$store.state.device.color, 'background-color':this.$store.state.device.color }"><span class="number_progression_active"><b>1</b></span></span></b-col>
                        <b-col cols="3" class="progress_col"><hr class="hr" :style="{'background-color': this.$store.state.device.color}"></b-col>
                        <b-col cols="2" class="progress_col"><span class="dot_active" :style="{'border': '3px solid'+this.$store.state.device.color, 'background-color':this.$store.state.device.color }"><span class="number_progression_active"><b>2</b></span></span></b-col>
                        <b-col cols="3" class="progress_col"><hr class="hr" :style="{'background-color': this.$store.state.device.color}"></b-col>
                        <b-col cols="2" class="progress_col"><span class="dot_not_active" :style="{'border': '3px solid'+this.$store.state.device.color}"><span class="number_progression_not_active">3</span></span></b-col>
                    </b-row>
                    <div style="width: 80%;margin: 10% auto 20%;">
                        <div style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.PaymentTitle') }}</b></label></div>
                        <br>
                        <br>
                        <b-form-group>
                            <legend>{{ $t('pages.Registration.MemberType') }}</legend>
                            <b-form-group style="margin-top: 5%;">
                                <b-form-select style="width: 100%; border-radius: 32px;" v-model="type" :options="options_type"></b-form-select>
                            </b-form-group>
                        </b-form-group>
                        <br>
                        <b-form-group>
                            <legend>{{ $t('pages.Registration.PaymentLabel') }}</legend>
                            <b-form-group style="margin-top: 5%;">
                                <b-form-select style="width: 100%; border-radius: 32px;" v-model="selected" :options="options"></b-form-select>
                            </b-form-group>
                        </b-form-group>

                        <div style="text-align: left;margin-top: 5%;">
                            <a v-on:click="back"><i style="margin-right: 10px;" class="fas fa-chevron-left"></i>{{ $t('standard.back') }}</a>
                        </div>

                        <b-button id="btnNext" v-on:click="next">
                            {{$t('standard.next')}}
                            <i style="padding-left: 10px;" class="fas fa-arrow-circle-right"></i>
                        </b-button>
                    </div>
                </b-form>
            </div>
         </div>
    </div>
</template>

<script>
  import NavbarTop from "../components/navbarTop";
  import navbarBottom from "../components/navbarBottom";
  import sideBar from "../components/sideBar"
  import {mutations} from "../store/modules/createSocio";
  const pt = require('../translations/pt-PT/pt-PT');
  const en = require('../translations/en-GB/en-GB');
  export default {
    name: "Registar",
    data() {
      return {
          selected: 0,
          options: [],
          options_type: [],
          type: 1
      };
    },
    components: { NavbarTop, navbarBottom, sideBar},
    methods: {
      next() {
          mutations.changeNumberOfPayments(this.selected);
          mutations.changeType(this.type);
          this.$router.push('/createSocio3');
      },
      back() {
        this.selected = 0;
        this.type = 1;
        this.$router.push('/createSocio');
      }
    },
    mounted() {
        this.selected = this.$store.state.createSocio.number_of_payments_year;
        this.type = this.$store.state.createSocio.type;
        this.options_type = [{ value: 1, text: "Normal" },
                             { value: 2, text: "Idoso" },
                             { value: 3, text: "Criança" },
                             { value: 4, text: "Atleta" },
                             { value: 5, text: "Mulher" }]
        if(this.$i18n.locale()=='pt') {
            this.options = [{ value: 0, text: pt.pages.Registration.PaymentDropNoPayment },
                { value: 1, text: pt.pages.Registration.PaymentDropMonth },
                { value: 3, text: pt.pages.Registration.PaymentDropTrimester },
                { value: 6, text: pt.pages.Registration.PaymentDropSemester },
                { value: 12, text: pt.pages.Registration.PaymentDropYear }]
        }
        if(this.$i18n.locale()=='en') {
            this.options = [{ value: 0, text: en.pages.Registration.PaymentDropNoPayment },
                { value: 1, text: en.pages.Registration.PaymentDropMonth },
                { value: 3, text: en.pages.Registration.PaymentDropTrimester },
                { value: 6, text: en.pages.Registration.PaymentDropSemester },
                { value: 12, text: en.pages.Registration.PaymentDropYear }]
        }

    }
  };
</script>

<style scoped>
    .form {
        padding-top: 80px;
        padding-bottom: 40px;
    }
    .progress_row {
        width: 80%;
        margin: auto;
    }
    .progress_col {
        padding: 0;
    }
    #btnNext {
        width: 40%;
        background: #2B2D42 0% 0% no-repeat padding-box;
        border-radius: 32px;
        color: white;
        border: none;
        letter-spacing: 0.85px;
        text-align: center;
        position: fixed;
        bottom: 68px;
        right: 10px;
    }
    @media (max-width: 330px) {
        .label_next {
            width: 100%;
            height: 100%;
            margin: auto;
            padding-top: 5%
        }
        .hr {
            border: none;
            height: 3px;
            position: relative;
            margin: 30% auto auto;
        }
    }
    @media (min-width: 330px) {
        .label_next {
            width: 100%;
            height: 100%;
            margin: auto;
            padding-top: 6%
        }
        .hr {
            border: none;
            height: 3px;

            position: relative;
            margin: 25% auto auto;
        }
    }
  input {
    background: white;
    border-radius: 32px;
    height: 47px;
  }
  legend {
    color: #2B2D42;
    text-align: left;
    font-size: 16px;
    letter-spacing: 0.8px;
    margin-bottom: 2%;
  }

    .dot_not_active {
        height: 100%;
        width: 100%;
        background-color: white;
        border-radius: 50%;
        display: flex;
    }

    .dot_active {
        height: 100%;
        width: 100%;
        border-radius: 50%;
        display: flex;
    }

    .number_progression_not_active {
        color: #2B2D42 ;
        margin: auto;
        font-size: 20px;
    }

    .number_progression_active {
        color: white;
        margin: 10%;
        font-size: 20px;
        padding-left: 25%;
    }

</style>
